// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Private Endpoint Service API
 * private-endpoint-service-api manages Private Endpoint Services in ingress clusters
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-networking@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GlobalPreRelease } from './GlobalPreRelease';
import {
  GlobalPreReleaseFromJSON,
  GlobalPreReleaseFromJSONTyped,
  GlobalPreReleaseToJSON,
  GlobalPreReleaseToJSONTyped,
} from './GlobalPreRelease';

/**
 *
 * @export
 * @interface SetGlobalPreRelease200Response
 */
export interface SetGlobalPreRelease200Response {
  /**
   *
   * @type {GlobalPreRelease}
   * @memberof SetGlobalPreRelease200Response
   */
  data: GlobalPreRelease;
}

/**
 * Check if a given object implements the SetGlobalPreRelease200Response interface.
 */
export function instanceOfSetGlobalPreRelease200Response(
  value: object,
): value is SetGlobalPreRelease200Response {
  if (!('data' in value) || value['data'] === undefined) return false;
  return true;
}

export function SetGlobalPreRelease200ResponseFromJSON(
  json: any,
): SetGlobalPreRelease200Response {
  return SetGlobalPreRelease200ResponseFromJSONTyped(json, false);
}

export function SetGlobalPreRelease200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SetGlobalPreRelease200Response {
  if (json == null) {
    return json;
  }
  return {
    data: GlobalPreReleaseFromJSON(json['data']),
  };
}

export function SetGlobalPreRelease200ResponseToJSON(
  json: any,
): SetGlobalPreRelease200Response {
  return SetGlobalPreRelease200ResponseToJSONTyped(json, false);
}

export function SetGlobalPreRelease200ResponseToJSONTyped(
  value?: SetGlobalPreRelease200Response | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    data: GlobalPreReleaseToJSON(value['data']),
  };
}
